export default {"src":"/_next/static/media/massage.fe0386fb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};